import React from 'react';
import './GridDetailsPanel.scss';
import {
    getGridPanelRows,
    GridDetailsPanelColumnDef,
} from 'utils/components/GridDetailsPanel/gridDetailsPanelColumnDef';
import { ResponsiveColumns } from 'utils/components/ResponsiveColumns/ResponsiveColumns';
import { GridDetailsPanelRow } from 'utils/components/GridDetailsPanel/GridDetailsPanelRow';
import { EnhancedColDef } from '@instinet-analytics/semantic-ui-components';
import { DetailsPanel } from 'utils/components/DetailsPanel/DetailsPanel';

export interface GridDetailColDef<TData> extends EnhancedColDef<TData> {
    showDetailValue?: (data: TData | undefined) => boolean;
}
export interface GridDetailsPanelsProps<
    TColumnId extends string,
    TEntity extends Partial<Record<TColumnId, unknown>>,
> {
    colDefs: GridDetailColDef<TEntity>[];
    entity: TEntity;
    panelColumnDefs: GridDetailsPanelColumnDef<TColumnId>[];
    width: number;
}

/*
 * Render a details panel for an object shown in the grid, using the column definitions for formatting
 */
export function GridDetailsPanel<
    TColumnId extends string,
    TEntity extends Partial<Record<TColumnId, unknown>>,
>(props: GridDetailsPanelsProps<TColumnId, TEntity>) {
    const { colDefs, entity, panelColumnDefs, width } = props;

    const twoColumns = width > 400;

    const rows = getGridPanelRows(panelColumnDefs);

    return (
        <DetailsPanel className="GridDetailsPanel">
            <ResponsiveColumns width={width} breaks={[400]}>
                {rows.map((r, i) => (
                    <GridDetailsPanelRow
                        panelColumnDefs={r}
                        key={i}
                        entity={entity}
                        colDefs={colDefs}
                        twoColumns={twoColumns}
                    />
                ))}
            </ResponsiveColumns>
        </DetailsPanel>
    );
}
